import { round2 } from "./weeklyEACCalculations";

// ODC Burden Cost (per API doc): no escalation concept, one formula. Subcontract expenses add
// SM&H then G&A on top of SM&H; every other expense type skips SM&H and applies G&A directly to
// unburdenCost. Both rates come from the yearly indirect rate table — the same
// fringe/OH/SM&H/G&A data already fetched for the "Forecasted Rates" panel (detailedViewRatesData)
// — a single current year, not a full by-year table, so this is only accurate for buckets in that
// year (a documented gap in the API doc; other years keep their persisted burdenCost as-is since
// they're never recomputed here).
export const recalculateOdcBucketBurdenCost = (bucket, odc, rates = {}) => {
  const unburdenCost = Number(bucket.unburdenCost) || 0;
  const applyBurden = odc.applyBurden !== false;
  const smAndHRate = applyBurden ? Number(rates.smAndH) || 0 : 0;
  const gAndARate = applyBurden ? Number(rates.gAndA) || 0 : 0;

  if (odc.expenseType === "Subcontract") {
    const smAndH = unburdenCost * (smAndHRate / 100);
    const gAndA = smAndH * (gAndARate / 100);
    return round2(unburdenCost + smAndH + gAndA);
  }

  const gAndA = unburdenCost * (gAndARate / 100);
  return round2(unburdenCost + gAndA);
};
